import React, { Component } from "react";

import { connect } from "react-redux";
import { Row } from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import DataTable from "../../../../components/Tables/tables";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

class ActionList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      // user: {},
      // updated: false,
      // searched: false,
      loading: true
    };
    this.insertAction = this.insertAction.bind(this);
  }

  insertAction() {
    this.props.history.push("/action/form");
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);
    axios
      .get(`${URL.api}audict/action/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          if (resp.data.success) {
            this.setState(
              () => ({
                list: null
              }),
              () => {
                if (resp.data.data.length === 0) {
                  this.setState(() => ({
                    list: [],
                    loading: false
                  }));
                } else {
                  this.setState(
                    () => ({
                      list: resp.data.data,
                      loading: false
                    }),
                    () => {
                      this.forceUpdate();
                    }
                  );
                }
              }
            );
          } else {
            this.props.logout(this.props.user.token);
          }
        },
        error => {
          if (error.response.statusText === "Unauthorized") {
            this.props.logout(this.props.user.token);
          }
        }
      );
  }

  render() {
    return (
      <div id="list" className="animated fadeIn">
        {this.state.loading ? (
          <Loading top="45" left="50" />
        ) : (
          <Row>
            <Breadcrumb current={this.props.currentRoute} />
            {this.state.list ? (
              <DataTable
                list={this.state.list}
                path="/action/edit/"
                title="Tabela de ação"
                header={[
                  { name: "id", denomination: "ID" },
                  { name: "name", denomination: "Ação" }
                ]}
                csv
                insert
                delete
                insertAction={this.insertAction}
              />
            ) : (
              "Loading..."
            )}
          </Row>
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ActionList);
